import React from 'react'
import style from "./styles/common.module.css"

export const NewFooter = () => {
  return (
    <div className={style.footer+' mt-5 py-3 position-relative d-sm-block d-none'}>
        <div className={' container d-flex justify-content-between align-items-center'}>
            <div className={style.left}>
                <a href="#" className='d-flex align-items-center gap-2'>
                    <img src="/icons/logo.svg" width={35} alt="" />
                    <span>SHiELD</span>
                </a>
            </div>
            <div className={style.center}>
                <p className='mb-0 '>All rights reserved @2025</p>
            </div>
            <div className={style.right+' d-flex gap-3'}>
                <a href="https://t.me/shield_protocol" target='_blank'>
                    <img src="/icons/tg.svg" alt="" />
                </a>
                <a href="https://shield-pro.gitbook.io/shield" target='_blank'>
                    <img src="/icons/gitbook.svg" style={{width:"27px"}} alt="" />
                </a>
                <a href="https://x.com/ShieldProtocols" target='_blank'>
                    <img src="/icons/twiter.svg" alt="" />
                </a>
            </div>
        </div>
    </div>
  )
}